import * as React from 'react';
import { HomeWrapper, MainHome } from './Home_SC';
import UpdatesPreview from './UpdatesPreview/UpdatesPreview';
import { AppSideDisplay, DefaultButton, AppIconsWhite } from '@inmoment/the-kitchen';
import { HOME_PAGE_TEXT } from '../../../utils/copy';
import { KitchenThemeContext } from '../../../App';
const {
  mainDisplay: { headingText, bodyText },
} = HOME_PAGE_TEXT;

export interface Props {}

export const Home: React.FC<Props> = (props) => {
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <HomeWrapper>
      <MainHome>
        <div style={{ background: 'lightgrey' }}></div>
        <AppSideDisplay title={headingText} text={bodyText} icon={'kitchen' as AppIconsWhite} color={theme} style={{ maxWidth: 460, minWidth: 460 }}>
          <DefaultButton
            fill="outline"
            buttonSize="small"
            text="Ask a Question"
            contrast="high"
            style={{ marginRight: 18 }}
            onClick={() => window.open('https://inmoment.slack.com/messages/the-kitchen-inquiries/', '_blank')}
          />
          <DefaultButton
            fill="outline"
            buttonSize="small"
            text="Submit a Ticket"
            contrast="high"
            onClick={() => window.open('https://jira.inmoment.com/secure/CreateIssue!default.jspa?pid=13817', '_blank')}
          />
        </AppSideDisplay>
        <UpdatesPreview />
      </MainHome>
    </HomeWrapper>
  );
};
